export const sliderItems = [
    {
      id: 1,
      img: "https://i.ibb.co/RbqBxBS/istockphoto-1010215852-170667a-removebg-preview.png",
      title: "SUMMER SALE",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "FFE69A",
    },
    {
      id: 2,
      img: "https://i.ibb.co/gjFj4mS/istockphoto-1270108315-612x612-removebg-preview-1.png",
      title: "AUTUMN COLLECTION",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "EC9B3B",
    },
    {
      id: 3,
      img: "https://i.ibb.co/fkMSvSh/cdfb46f0-1134-11ea-9f4f-94cc3f772566-removebg.png",
      title: "LOUNGEWEAR LOVE",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "fbf0f4",
    },
  ];

  export const categories = [
    {
      id: 1,
      img: "https://images.pexels.com/photos/5886041/pexels-photo-5886041.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      title: "SHIRT STYLE!",
      cat:"Shirts"
    },
    {
      id: 2,
      img: "https://images.pexels.com/photos/2983464/pexels-photo-2983464.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      title: "LOUNGEWEAR",
      cat:"LoungeWear"
    },
    {
      id: 3,
      img: "https://images.pexels.com/photos/5480696/pexels-photo-5480696.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      title: "LIGHT JACKETS",
      cat:"Coat"
    },
    {
      id: 4,
      img: "https://i.pinimg.com/564x/18/c2/26/18c22688ac5e045373bcafe7f6fc6ddd.jpg",
      title: "DENIMS",
      cat:"Jeans"
    },
  ];

  export const popularProducts = [
    {
      id: 1,
      img:"https://i.ibb.co/JvY5ft6/1.png",
    },
    {
      id: 2,
      img:"https://i.ibb.co/JkCYrxY/2.png",
    },
    {
      id: 3,
      img:"https://www.prada.com/content/dam/pradanux_products/U/UCS/UCS319/1YOTF010O/UCS319_1YOT_F010O_S_182_SLF.png",
    },
    {
      id: 4,
      img:"https://www.burdastyle.com/pub/media/catalog/product/cache/7bd3727382ce0a860b68816435d76e26/107/BUS-PAT-BURTE-1320516/1170x1470_BS_2016_05_132_front.png",
    },
    {
      id: 5,
      img:"https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png",
    },
    {
      id: 6,
      img:"https://i.ibb.co/NTzZpXc/6.png",
    },
    {
      id: 7,
      img:"https://i.ibb.co/jLFMYCd/7.png",
    },
    {
      id: 8,
      img:"https://i.ibb.co/HnpRncC/8.png",
    },
    {
      id: 9,
      img:"https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png",
    },
  ]